import { http } from './http';
import type {
  NotificationListResponse,
  NotificationQueryParams,
  UnreadNotificationCountDto,
} from './types';

export const notificationsApi = {
  list(params: NotificationQueryParams = {}): Promise<NotificationListResponse> {
    return http
      .get<NotificationListResponse>('/notifications', { params })
      .then((r) => r.data);
  },

  unreadCount(): Promise<number> {
    return http
      .get<UnreadNotificationCountDto>('/notifications/unread-count')
      .then((r) => r.data.count);
  },

  markRead(id: string): Promise<void> {
    return http.post(`/notifications/${id}/read`).then(() => undefined);
  },

  markUnread(id: string): Promise<void> {
    return http.post(`/notifications/${id}/unread`).then(() => undefined);
  },

  markAllRead(): Promise<void> {
    return http.post('/notifications/read-all').then(() => undefined);
  },
};
